import {
    addClientMeasurerAccount,
    deleteClientMeasurerAccount,
    userSettingsDataQuery
} from '../graphql/queries/grid/userSettings';
import { mapMeasurerSystemFromApiToClient, mapMeasurerSystemFromClientToApi } from '../mappers/measurer';
import { MeasurerSystem } from '../typings/common';
import { addMeasurerAccount, deleteMeasurerAccount, UserSettingsDataQuery } from '../typings/graphql-grid';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';

interface AddMeasurerAccountInput {
    expires_at?: number;
    access_token: string;
    refresh_token: string;
}

export class UserSettingsDataProvider extends BaseDataProvider {
    public async fetchMeasurerSystem(login: string) {
        return this.createQuery<UserSettingsDataQuery>(userSettingsDataQuery, {
            variables: {
                login
            }
        }).then(response =>
            response.data.client.measurerAccounts.filter(Boolean).map(mapMeasurerSystemFromApiToClient)
        );
    }

    public async addMeasurerAccount(login: string, settings: AddMeasurerAccountInput, measurerSystem: MeasurerSystem) {
        return await this.client.awaitMutate<addMeasurerAccount>({
            mutation: addClientMeasurerAccount,
            login,
            variables: {
                input: {
                    measurerSystem: mapMeasurerSystemFromClientToApi(measurerSystem),
                    settings: JSON.stringify(settings)
                }
            }
        });
    }

    public async deleteMeasurerAccount(login: string, measurerSystem: MeasurerSystem) {
        return await this.client.awaitMutate<deleteMeasurerAccount>({
            mutation: deleteClientMeasurerAccount,
            login,
            variables: {
                measurerSystem: mapMeasurerSystemFromClientToApi(measurerSystem)
            }
        });
    }
}
